module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Steckborn-b042f6b588cb985007b36648b6a08e99.png";